var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"template",class:_vm.componentClass,on:{"dragenter":_vm.dragEnter,"dragover":_vm.dragEnter,"dragleave":_vm.dragLeave,"drop":_vm.drop}},[(_vm.checked)?_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"#4CBB17"}}):_vm._e(),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.value.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }